import * as React from 'react';
import {
    Card, DateTimeColumn, MultiRowColumn, SimpleTable, StatusColumn,
} from 'components';
import EditFileIcon from 'components/assets/svg/inbox.svg';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { useLoading } from 'hooks';
import { HEADER } from './TableHeader';
import { Color, ColorStatus } from '_helpers';
import Pagination from 'components/Pagination/Pagination';
import { useHistory } from 'react-router';

const ConductRequestsListContainer: React.FC<IProps> = (props) => {
    const { push } = useHistory();
    const [loading, fetchExams] = useLoading(props.fetchWaitingForApprovalExams);

    React.useEffect(() => {
        fetchExams();
    }, []);

    const rows = React.useMemo(() => {
        if (!props.waitingForApprovalExams) return [];
        return props.waitingForApprovalExams.items.map(i => ({
            id: i.id,
            columns: [
              <DateTimeColumn date={i.date} />,
              <MultiRowColumn rows={[i.qualificationTitle, `Этапы: ${[...Array(i.stagesNumber)].map((_, n) => n + 1).join(', ')}`]} />,
              <StatusColumn status={new ColorStatus(Color.Orange, 'Одобрить проведение')} />,
            ],
        }));
    }, [props.waitingForApprovalExams]);

    return (
      <Card
        withoutPadding
        showLoader={loading && !props.waitingForApprovalExams}
        title="Запросы на проведение"
        category="Список запросов от секретаря АПК на проведение аккредитационных мероприятий"
      >
          <SimpleTable
            placeholderTitle="Нет запросов на проведение"
            placeholderText="Здесь будут отображаться все запросы на проведение аккредитационных мероприятий"
            placeholderIcon={EditFileIcon}
            tableRows={rows}
            tableHeaders={HEADER}
            handleRowClick={id => push(`/exam/${id}?from=conduct-requests`)}
          />
          {props.waitingForApprovalExams && !!props.waitingForApprovalExams.items.length && (
            <Pagination
              onChange={d => props.fetchWaitingForApprovalExams({ page: d.page, pageSize: d.perPage })}
              pagination={{
                  page: props.waitingForApprovalExams.page,
                  perPage: props.waitingForApprovalExams.pageSize,
                  pages: Math.ceil(props.waitingForApprovalExams.total / props.waitingForApprovalExams.pageSize || 1),
              }}
            />
          )}
      </Card>
    );
};

const mapStateToProps = (state: IRootState) => ({
    waitingForApprovalExams: state.exams.waitingForApprovalExams,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchWaitingForApprovalExams: dispatch.exams.fetchWaitingForApprovalExams,
});

type ConnectedProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
type IProps = ConnectedProps;

export default connect(mapStateToProps, mapDispatchToProps)(ConductRequestsListContainer);
